module.exports = __webpack_public_path__ + "img/error-dark.ad214f8c.svg";